<template>
  <div id="app">
      <div
          class="text-center"
      >
          <global-header/>
      </div>
      <router-view
          class="container mx-auto px-4 lg:px-0"
      >
      </router-view>
      <global-footer />

      <div
      v-if="$store.state.loading">
          <loader></loader>
      </div>
  </div>
</template>

<script>
  // import Loading from '@/js/components/ui/Loading.vue'
  import GlobalHeader from '@/js/components/GlobalHeader.vue';
  import GlobalFooter from '@/js/components/GlobalFooter.vue';
  import Loader from '@/js/components/ui/Loader.vue';

  export default {
    components: {
      Loader,
      GlobalFooter,
      'global-header': GlobalHeader,
    },

    data () {
      return {

      }
    },

    mounted () {
      if (typeof window !== "undefined" && localStorage.getItem('laravelAuthToken')) {
          this.$store.dispatch('init', {uri: this.$route.path});
        this.$store.dispatch('GET_USER');
      }
    },
    metaInfo () {
      return this.$seo()
    },
    beforeMount () {
      var hubspot_script = document.createElement('script');
      hubspot_script.setAttribute('src','https://js.hs-scripts.com/1746707.js');
      hubspot_script.setAttribute('async',true);
      hubspot_script.setAttribute('defer',true);
      document.head.appendChild(hubspot_script);
    },
  }
</script>

<style lang="scss">
  body {
    overflow-y: scroll
  }
  a {
    text-decoration: none
  }

  .header {
    background-color: #f60;
    position: fixed;
    z-index: 999;
    height: 55px;
    top: 0;
    left: 0;
    right: 0
  }

  .header .inner {
    max-width: 800px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 15px 5px
  }

  .header a {
    color: hsla(0, 0%, 100%, .8);
    line-height: 24px;
    transition: color .15s ease;
    display: inline-block;
    vertical-align: middle;
    font-weight: 300;
    letter-spacing: .075em;
    margin-right: 1.8em
  }

  .header a:hover {
    color: #fff
  }

  .header a.router-link-active {
    color: #fff;
    font-weight: 400
  }

  .header a:nth-child(6) {
    margin-right: 0
  }

  .header .github {
    color: #fff;
    font-size: .9em;
    margin: 0;
    float: right
  }

  .logo {
    width: 24px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle
  }

  .view {
    max-width: 1000px;
    margin: 0 auto;
    position: relative
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  @media (max-width: 860px) {
    .header .inner {
      padding: 15px 30px
    }

  }

  @media (max-width: 600px) {
    .header .inner {
      padding: 15px
    }

    .header a {
      margin-right: 1em
    }

    .header .github {
      display: none
    }

  }
</style>
